import {Button, VisuallyHidden} from '@primer/react'
import {Dialog} from '@primer/react/experimental'

import {PROJECTS_DOCS_URL, WELCOME_DESCRIPTION, WELCOME_TITLE} from './constants'
import styles from './WelcomeSplashDialog.module.css'

interface WelcomeSplashDialogProps {
  onDismiss: () => void
}

/**
 * Modal welcome splash for the repo Projects React page.
 */
export function WelcomeSplashDialog({onDismiss}: WelcomeSplashDialogProps) {
  return (
    <Dialog
      title={WELCOME_TITLE}
      onClose={onDismiss}
      width="large"
      renderFooter={() => (
        <Dialog.Footer>
          <Button as="a" href={PROJECTS_DOCS_URL} target="_blank" rel="noopener noreferrer">
            Learn more
            <VisuallyHidden>&nbsp;(opens in a new tab)</VisuallyHidden>
          </Button>
          <Button variant="primary" onClick={onDismiss}>
            Jump right in
          </Button>
        </Dialog.Footer>
      )}
    >
      <picture>
        <source
          media="(prefers-color-scheme: dark) and (max-width: 767px)"
          srcSet="/images/modules/memexes/projects-beta-splash-mobile-dark.png"
        />
        <source media="(max-width: 767px)" srcSet="/images/modules/memexes/projects-beta-splash-mobile.png" />
        <source media="(prefers-color-scheme: dark)" srcSet="/images/modules/memexes/projects-beta-splash-dark.png" />
        <img
          src="/images/modules/memexes/projects-beta-splash.png"
          alt=""
          width={1400}
          height={800}
          className={styles.heroImage}
        />
      </picture>
      <p className={styles.body}>{WELCOME_DESCRIPTION}</p>
    </Dialog>
  )
}
